import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  bodmasTestQuestionsData: [],
  bodmasTestQuestionsCount: 0,
  bodmasTestQuestionsDetails: {},
  isOpenModal: false,
  isStatusOpenModal: false,
  addPreview: false,
  addPreviewId: "",
  examLanguage: 'english',
}

export const BodmasTestQuestionsSlice = createSlice({
  name: "BodmasTestQuestions",
  initialState,
  reducers: {
    setBodmasTestQuestionsData(state, { payload }) {
      state.bodmasTestQuestionsData = payload.result
      state.bodmasTestQuestionsCount = payload.count
    },
    setBodmasTestQuestionsDetails(state, { payload }) {
      state.bodmasTestQuestionsDetails = payload
    },
    updateBodmasTestQuestionsData(state, { payload }) {
      const objIndex = state.bodmasTestQuestionsData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.bodmasTestQuestionsData[objIndex] = payload
      }
    },
    deleteBodmasTestQuestionsData(state, { payload }) {
      const objIndex = state.bodmasTestQuestionsData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.bodmasTestQuestionsData.splice(objIndex, 1)
      }
    },
    pushBodmasTestQuestionsData(state, { payload }) {
      state.bodmasTestQuestionsData.push(payload)
    },
    setAddPreview(state, { payload }) {
      state.addPreview = true;
      state.addPreviewId = payload.result._id
    },
    removeAddPreview(state) {
      state.addPreview = false
    },
    examLanguage(state, { payload }) {
      state.examLanguage = payload
    }
  }
})

export const { setAddPreview, setBodmasTestQuestionsData, setBodmasTestQuestionsDetails, removeAddPreview, updateBodmasTestQuestionsData, deleteBodmasTestQuestionsData, pushBodmasTestQuestionsData, examLanguage } = BodmasTestQuestionsSlice.actions;

export default BodmasTestQuestionsSlice.reducer;

export function getBodmasTestQuestions(id, limit, offset) {
  return async function getBodmasTestQuestionsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getBodmasTestQuestions(id, limit, offset).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setBodmasTestQuestionsData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function getBodmasTestQuestionsById(id) {
  return async function getBodmasTestQuestionsByIdThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getBodmasTestQuestionsById(id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setBodmasTestQuestionsDetails(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addBodmasTestQuestions(payload) {
  return async function addBodmasTestQuestionsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addBodmasTestQuestions(payload).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(pushBodmasTestQuestionsData(response.data))
          dispatch(setAddPreview(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateBodmasTestQuestions(payload) {
  return async function updateBodmasTestQuestionsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateBodmasTestQuestions(payload.questionId, payload.data).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setAddPreview(response.data))
          dispatch(updateBodmasTestQuestionsData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}


export function statusDeleteBodmasTestQuestions(payload) {
  return async function statuseleteBodmasTestQuestionsThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteBodmasTestQuestions(payload).then(
        (response) => {
          dispatch(deleteBodmasTestQuestionsData(payload))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

